import React, {useState} from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import { Normalize } from 'styled-normalize'
import styled, {createGlobalStyle} from 'styled-components'
import { Emoji, Extern } from "./../components/helpers.js"
import favicon from './../img/favicon.png'
import { Helmet } from 'react-helmet'
import Menu from "./../components/menu.js"
import { titleCase } from "title-case";

const GlobalStyle = createGlobalStyle`
    body {
        overflow-y:scroll;
    }
`

export default (props) => {

    const Layout = styled.div`
        font-size: 1.1em;
        font-family: 'Merriweather', 'Lucida Bright', serif;
        font-display: swap;
        background-color: #fff;
        color: #444;   

        @media screen and (max-width: 600px) {
            font-size: 0.95em;
        }
        
        ol li {
            margin-bottom:0.7em;
        }

        p, li {
            line-height:1.9em;    
        }

        h1, h2, h3, h4, h5 {
            font-family: 'Arial', sans-serif;
            color:#000;
        }

        a {
            color:#000;
            &:hover {
                color:#999;
            }
        }
    `;

        const Header = styled.div`   
        background-color: #fff;
        width: 100%;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        z-index:1;
        position:relative;
        div 
        {
            width:1200px;
            max-width:90vw;
            margin:0px auto;
        }

        @media screen and (max-width: 1024px) {
            & > div {
                width:100%;
                max-width:100%;
            }
        }
    `;

    const Logo = styled.h1`
        padding:0px;
        margin:16px;
        margin-left:0px;
        height:44px;
        display:inline-block;

        @media screen and (max-width: 1024px) {
            margin-left:3vw;
        }
    `;

    const Hero = styled.div`
        min-height:23vh;
        padding-bottom:30px;
        margin-bottom:1em;
        box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.2);
        display:flex;
        align-items: flex-end;
        flex-flow: wrap;
        background-color:#000;

        div {               
            width:1200px;
            max-width:90vw;
            margin:0px auto;
            
        }
        
        h1 {
            padding-top:60px; 
            font-size:2.8em;
            color:#fff;
            margin:0px;
            max-width:900px;
            line-height:1.3em;
        }

        p {   
            padding-top:12px;       
            font-size:1.6em;
            color:#fff;
            margin:0px;
            max-width:800px;
        }

        @media screen and (max-width: 1024px) {

            div {
                width: 710px;
            }

            h1 {
                max-width: 710px;
            }
        }
    `;

    const Flexbox = styled.div`
        width:1200px;
        max-width:90vw;
        margin:0px auto 24px auto;
        display:flex;
        flex-flow: wrap;
        
        @media screen and (max-width: 1024px) {
            width: 710px;
            ${props.swap ? 'flex-wrap: wrap-reverse;' : ''}
        }
    
        button {
            background-color:#222;
            color:#fff;
            font-family: 'Arial', sans-serif;
            font-size:0.95em;
            margin-bottom:1em;
            margin-top:0.5em;
            padding:0.8em;
            border-radius:3px;
            display:block;
            text-align:center;
            text-decoration:none;
            cursor:pointer;
            border:none;
            svg {
                margin-right:3px;
            }
            :hover {
                color:#fff;
                opacity:0.9;
            }
        }
    `;

    
    const Notif = styled.div`        
        background-color: #f5fde6ff;

        p {
            display:block;
            font-family: 'Arial', sans-serif;
            padding:1em 1em 0.8em 1em;
            margin:0px auto;
            font-size:1em;      
            color: #65c809ff; 
            max-width: 1200px;

            a {
                color: #65c809ff;
                font-weight: bold;
            }

            a:hover {
                color: #448309ff;
            }
        }
    `;

    const Content = styled.div`
        flex:2;
        max-width: 710px;
        margin-right:3.5em;

        @media screen and (max-width: 1024px) {
        margin-right:0px;
        flex:100%;
        }
    `;

    const Content2 = styled.div`
        display:none;

        @media screen and (max-width: 1024px) {
            ${props.swap ? 'display: block;border-top:1px #ddd solid;' : ''}
        }
    `;

    const SidebarMain = styled.div`    
        box-shadow: 0px 0px 3px 0px rgba(0,0,0,0.2);
        overflow-y:auto;
        padding:0px 16px;    
        border-radius:5px;
        margin-top:16px;
        /* max-height:calc(100vh - 130px); */
        background-color: #fdfdfd;      
    `;

    const Sidebar2 = styled.div`
        padding:6px 19px;    

        @media screen and (max-width: 1024px) {
            ${props.swap ? 'display: none;' : ''}
        }
    `;

    const Sidebar = styled.div`
        flex:1;        
        max-width: 710px;
        /* top:24px; */
        align-self: flex-start;
        position: relative;
        -webkit-position: relative;

        @media screen and (max-width: 1024px) {
            flex:100%;
            top: 24px;
            margin-top: -18px;
            ${props.swap ? 'margin-bottom: 32px;' : ''}
            position:relative;
            -webkit-position: relative;
        }    
    `;

    const [menu, setMenu] = useState(false);
    const [submenu, setSubmenu] = useState(false);
    
    var header;
    if (typeof props.heroJSX !== 'undefined')
        header = props.heroJSX;
    else
        header = <div><h1>{titleCase(props.title)}</h1></div>;

    var color1;
    var color2;
    if (typeof props.color1 === 'undefined')
    {
        color1 = '#642b73';
        color2 = '#c6426e';
    }
    else
    {
        color1 = props.color1;
        color2 = props.color2;
    }

    const ColoredHero = styled(Hero)`
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 304 304' width='304' height='304'%3E%3Cpath fill='%23FFFFFF' fill-opacity='0.05' d='M44.1 224a5 5 0 1 1 0 2H0v-2h44.1zm160 48a5 5 0 1 1 0 2H82v-2h122.1zm57.8-46a5 5 0 1 1 0-2H304v2h-42.1zm0 16a5 5 0 1 1 0-2H304v2h-42.1zm6.2-114a5 5 0 1 1 0 2h-86.2a5 5 0 1 1 0-2h86.2zm-256-48a5 5 0 1 1 0 2H0v-2h12.1zm185.8 34a5 5 0 1 1 0-2h86.2a5 5 0 1 1 0 2h-86.2zM258 12.1a5 5 0 1 1-2 0V0h2v12.1zm-64 208a5 5 0 1 1-2 0v-54.2a5 5 0 1 1 2 0v54.2zm48-198.2V80h62v2h-64V21.9a5 5 0 1 1 2 0zm16 16V64h46v2h-48V37.9a5 5 0 1 1 2 0zm-128 96V208h16v12.1a5 5 0 1 1-2 0V210h-16v-76.1a5 5 0 1 1 2 0zm-5.9-21.9a5 5 0 1 1 0 2H114v48H85.9a5 5 0 1 1 0-2H112v-48h12.1zm-6.2 130a5 5 0 1 1 0-2H176v-74.1a5 5 0 1 1 2 0V242h-60.1zm-16-64a5 5 0 1 1 0-2H114v48h10.1a5 5 0 1 1 0 2H112v-48h-10.1zM66 284.1a5 5 0 1 1-2 0V274H50v30h-2v-32h18v12.1zM236.1 176a5 5 0 1 1 0 2H226v94h48v32h-2v-30h-48v-98h12.1zm25.8-30a5 5 0 1 1 0-2H274v44.1a5 5 0 1 1-2 0V146h-10.1zm-64 96a5 5 0 1 1 0-2H208v-80h16v-14h-42.1a5 5 0 1 1 0-2H226v18h-16v80h-12.1zm86.2-210a5 5 0 1 1 0 2H272V0h2v32h10.1zM98 101.9V146H53.9a5 5 0 1 1 0-2H96v-42.1a5 5 0 1 1 2 0zM53.9 34a5 5 0 1 1 0-2H80V0h2v34H53.9zm60.1 3.9V66H82v64H69.9a5 5 0 1 1 0-2H80V64h32V37.9a5 5 0 1 1 2 0zM101.9 82a5 5 0 1 1 0-2H128V37.9a5 5 0 1 1 2 0V82h-28.1zm16-64a5 5 0 1 1 0-2H146v44.1a5 5 0 1 1-2 0V18h-26.1zm102.2 270a5 5 0 1 1 0 2H98v14h-2v-16h124.1zM242 149.9V160h16v34h-16v62h48v48h-2v-46h-48v-66h16v-30h-16v-12.1a5 5 0 1 1 2 0zM53.9 18a5 5 0 1 1 0-2H64V2H48V0h18v18H53.9zm112 32a5 5 0 1 1 0-2H192V0h50v2h-48v48h-28.1zm-48-48a5 5 0 0 1-9.8-2h2.07a3 3 0 1 0 5.66 0H178v34h-18V21.9a5 5 0 1 1 2 0V32h14V2h-58.1zm0 96a5 5 0 1 1 0-2H137l32-32h39V21.9a5 5 0 1 1 2 0V66h-40.17l-32 32H117.9zm28.1 90.1a5 5 0 1 1-2 0v-76.51L175.59 80H224V21.9a5 5 0 1 1 2 0V82h-49.59L146 112.41v75.69zm16 32a5 5 0 1 1-2 0v-99.51L184.59 96H300.1a5 5 0 0 1 3.9-3.9v2.07a3 3 0 0 0 0 5.66v2.07a5 5 0 0 1-3.9-3.9H185.41L162 121.41v98.69zm-144-64a5 5 0 1 1-2 0v-3.51l48-48V48h32V0h2v50H66v55.41l-48 48v2.69zM50 53.9v43.51l-48 48V208h26.1a5 5 0 1 1 0 2H0v-65.41l48-48V53.9a5 5 0 1 1 2 0zm-16 16V89.41l-34 34v-2.82l32-32V69.9a5 5 0 1 1 2 0zM12.1 32a5 5 0 1 1 0 2H9.41L0 43.41V40.6L8.59 32h3.51zm265.8 18a5 5 0 1 1 0-2h18.69l7.41-7.41v2.82L297.41 50H277.9zm-16 160a5 5 0 1 1 0-2H288v-71.41l16-16v2.82l-14 14V210h-28.1zm-208 32a5 5 0 1 1 0-2H64v-22.59L40.59 194H21.9a5 5 0 1 1 0-2H41.41L66 216.59V242H53.9zm150.2 14a5 5 0 1 1 0 2H96v-56.6L56.6 162H37.9a5 5 0 1 1 0-2h19.5L98 200.6V256h106.1zm-150.2 2a5 5 0 1 1 0-2H80v-46.59L48.59 178H21.9a5 5 0 1 1 0-2H49.41L82 208.59V258H53.9zM34 39.8v1.61L9.41 66H0v-2h8.59L32 40.59V0h2v39.8zM2 300.1a5 5 0 0 1 3.9 3.9H3.83A3 3 0 0 0 0 302.17V256h18v48h-2v-46H2v42.1zM34 241v63h-2v-62H0v-2h34v1zM17 18H0v-2h16V0h2v18h-1zm273-2h14v2h-16V0h2v16zm-32 273v15h-2v-14h-14v14h-2v-16h18v1zM0 92.1A5.02 5.02 0 0 1 6 97a5 5 0 0 1-6 4.9v-2.07a3 3 0 1 0 0-5.66V92.1zM80 272h2v32h-2v-32zm37.9 32h-2.07a3 3 0 0 0-5.66 0h-2.07a5 5 0 0 1 9.8 0zM5.9 0A5.02 5.02 0 0 1 0 5.9V3.83A3 3 0 0 0 3.83 0H5.9zm294.2 0h2.07A3 3 0 0 0 304 3.83V5.9a5 5 0 0 1-3.9-5.9zm3.9 300.1v2.07a3 3 0 0 0-1.83 1.83h-2.07a5 5 0 0 1 3.9-3.9zM97 100a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-48 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 48a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 96a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-144a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-96 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm96 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-32 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM49 36a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-32 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM33 68a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-48a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 240a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm80-176a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 48a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm112 176a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM17 180a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM17 84a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6z'%3E%3C/path%3E%3C/svg%3E"), linear-gradient(to right, ${color1}, ${color2});
    `;

    const data = useStaticQuery(graphql`
        query {
            logo: file(relativePath: { eq: "logo.png" }) {
                childImageSharp {
                    fixed(width: 228) {
                    ...GatsbyImageSharpFixed_noBase64
                    }
                }
            }
            projects: allDataJson {
            nodes {
                projects {
                name
                }
            }
            }
        }
    `)

    var projectlist = data.projects.nodes[0].projects;

    const menuContent = <>
    <Logo><Link to="/"><Img fadeIn={false} fixed={data.logo.childImageSharp.fixed} alt="Maakbaas" /></Link></Logo>
    <Menu projects={projectlist} 
        visible={menu} 
        subvisible={submenu} 
        setSubmenu={(val) => {setSubmenu(val)}}        
        setMenu={(val) => {setMenu(val)}}        
    />
    </>;

    var dommenu = <>
        <Header><div>
            {menuContent}
        </div></Header>

        
        <ColoredHero>{header}</ColoredHero></>;
    
    return ( <>
        <Helmet>
            <link rel="icon" href={favicon} />
        </Helmet>

        <Normalize />
        <GlobalStyle />
        <Layout onClick={() => { setSubmenu(false); setMenu(false) }}>             
            {dommenu}

            <Flexbox>
                <Content>
                    {props.content}
                    {props.swap? <Content2>{props.sidebar2}</Content2> : <></>}
                </Content>
                <Sidebar>
                    <SidebarMain>
                        {props.sidebar}
                    </SidebarMain>
                    <Sidebar2>
                        {props.sidebar2}
                    </Sidebar2>
                </Sidebar>            
            </Flexbox>

        </Layout>
    </>);

}
